import { PostHogProvider as PostHogProviderBase } from 'posthog-js/react';
import React from 'react';

import { config } from '~/config';

export const PostHogProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  if (['staging', 'prod'].includes(config.app.environment)) {
    return (
      <PostHogProviderBase
        apiKey={config.posthog.apiKey}
        options={{
          api_host: config.posthog.apiHost,
          ui_host: config.posthog.uiHost,
          defaults: '2025-05-24',
          capture_exceptions: true,
          persistence: 'localStorage',
          debug: false,
          session_recording: {
            maskTextSelector: '.email-address',
          },
        }}
      >
        {children}
      </PostHogProviderBase>
    );
  }

  return <>{children}</>;
};
